import React from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { sortableHandle } from 'react-sortable-hoc';

const DragHandle = sortableHandle(() => (
  <MenuOutlined className="drag-handle" />
));

export const mobileCardsActiveColumns = (dispatch) => [
  {
    title: '',
    dataIndex: 'sort',
    width: 30,
    className: 'drag-visible',
    render: () => <DragHandle />,
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 35,
    className: 'drag-visible',
  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
    className: 'drag-visible',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'User Type',
    dataIndex: 'userType',
    key: 'userType',
  },
  {
    title: 'Phase',
    dataIndex: 'phase',
    key: 'phase',
  },
  {
    title: 'Order',
    dataIndex: 'order',
    key: 'order',
  },
  {
    title: 'Date Published',
    dataIndex: 'publishedAt',
    key: 'publishedAt',
  },
];

export const mobileCardsOnQueueColumns = (dispatch) => {
  const active = mobileCardsActiveColumns(dispatch);
  active[7] = {
    title: 'Date Created',
    dataIndex: 'createdAt',
    key: 'createdAt',
  };

  return active;
};

export const mobileCardsExpiredColumns = (dispatch) => mobileCardsActiveColumns(dispatch);

export const fixtureData = [{
  id: 1,
  title: 'Example',
  type: 'Hero Banner',
  userType: 'Select',
  phase: 'Add-Ons',
  order: 1,
  createdAt: '05/18/2020 23:59:59',
  publishedAt: '07/18/2020 00:45:26',
}];
